import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setGroupCheckListSelectedItem } from 'app/actions/transport';
import { Autosizer, Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const TransportGroupCheckList = () => {
    const dispatch = useDispatch();
    const { checklists } = useSelector((state) => state.transport.groupSelectedItem);
    const { checkListSelectedItem } = useSelector((state) => state.transport);
    const handleItemClick = (value) => {
        dispatch(setGroupCheckListSelectedItem(value));
    };
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItem-root': {
                width: '100%',
                userSelect: 'none',
                padding: theme.spacing(0),
                borderRadius: '0',
                '.MuiListItemIcon-root': {
                    justifyContent: 'end',
                    '.MuiCheckbox-root': {
                        padding: theme.spacing(0),
                        marginRight: theme.spacing(0),
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiListItemAvatar-root': {
                    minWidth: '36px',
                },
                '.MuiAvatar-circular': {
                    width: '24px',
                    height: '24px',
                    color: theme.palette.primary.main,
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    svg: {
                        fontSize: '16px',
                        path: {
                            fill: theme.palette.primary.main,
                        },
                    },
                },
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    borderRadius: '0',
                },
                '.MuiListItemText-root': {
                    margin: theme.spacing(0),
                },
                '.MuiChip-root': {
                    height: '20px',
                    span: {
                        fontSize: '10px',
                        color: 'white',
                    },
                },
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { height: height, itemSize: 36, overscanCount: 10, itemCount: checklists.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: TransportGroupCheckListInnerElementType, itemData: {
                    items: checklists,
                    selectedItem: checkListSelectedItem,
                    onClick: handleItemClick,
                } }, TransportGroupCheckListItemRender))))))));
};
const TransportGroupCheckListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
TransportGroupCheckListInnerElementType.displayName = 'TransportGroupCheckListInnerElementType';
const TransportGroupCheckListItemRender = ({ data, index, style }) => {
    const { items, selectedItem, onClick } = data;
    const item = items[index];
    return (React.createElement(ListItem, { key: item.id, style: style, selected: item.id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), onClick: () => onClick(item), secondaryAction: React.createElement(Chip, { size: 'small', label: item.active ? 'Активен' : 'Удален', color: item.active ? 'success' : 'error' }) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemAvatar, null,
                React.createElement(Avatar, null,
                    React.createElement(InspectionIcon, { fontSize: 'small' }))),
            React.createElement(ListItemText, { primary: item.name }))));
};
export default TransportGroupCheckList;
